import React from 'react'
import classes from './YearFees.module.css'
import StatusChips from '../StatusChips/StatusChips'
const YearFeesField = ({
  label,
  name,
  secName,
  subtxt,
  secsubtxt,
  italictxt,
  status,
  statusValue,
  disabled
}) => {
  return (
    <div>
      <div className={classes.box}>
        <label className={classes.txt}>
          {label} <br />
          <span className={classes.span}>{italictxt}</span>
        </label>
        <div className={classes.field}>
          {status ? (
            <StatusChips status={statusValue} />
          ) : (
            <>
              {subtxt && <span className={classes.subtxt}>{subtxt}:</span>}
              <span className={classes.maintxt}>{name}</span>
              {secName && (
                <>
                  <span className={classes.subtxt}>|</span>
                  <span className={classes.subtxt}>{secsubtxt}:</span>{' '}
                  <span className={classes.maintxt}>{secName}</span>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default YearFeesField
